var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 16 15",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45 1.66667C3.5 2.40833 3.625 3.13333 3.825 3.825L2.825 4.825C2.48333 3.825 2.26667 2.76667 2.19167 1.66667H3.45ZM11.6667 11.6833C12.375 11.8833 13.1 12.0083 13.8333 12.0583V13.3C12.7333 13.225 11.675 13.0083 10.6667 12.675L11.6667 11.6833ZM4.25 0H1.33333C0.875 0 0.5 0.375 0.5 0.833333C0.5 8.65833 6.84167 15 14.6667 15C15.125 15 15.5 14.625 15.5 14.1667V11.2583C15.5 10.8 15.125 10.425 14.6667 10.425C13.6333 10.425 12.625 10.2583 11.6917 9.95C11.6083 9.91667 11.5167 9.90833 11.4333 9.90833C11.2167 9.90833 11.0083 9.99167 10.8417 10.15L9.00833 11.9833C6.65 10.775 4.71667 8.85 3.51667 6.49167L5.35 4.65833C5.58333 4.425 5.65 4.1 5.55833 3.80833C5.25 2.875 5.08333 1.875 5.08333 0.833333C5.08333 0.375 4.70833 0 4.25 0Z",
    fill: "#7D8082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bee54ac46479a826654d6736e57abd70.svg";
export { ForwardRef as ReactComponent };